/* Strongman — mejoras de UX ligeras (auditoría oct-2026). Sin dependencias. */
(function () {
  /* Descripción de colección en móvil: 3 líneas + "Leer más" (el texto completo sigue en el HTML para SEO). */
  function clampCollectionText() {
    if (!document.body.classList.contains('template-collection')) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var box = document.querySelector('.articleLookbook-des');
    if (!box || box.dataset.smClamp) return;
    var lh = parseFloat(getComputedStyle(box.querySelector('p') || box).lineHeight) || 24;
    var max = Math.round(lh * 3);
    if (box.scrollHeight <= max + 4) return;
    box.dataset.smClamp = '1';
    box.classList.add('sm-clamp');
    box.style.maxHeight = max + 'px';
    if (!box.id) box.id = 'sm-collection-desc';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-more-btn';
    btn.textContent = 'Leer más';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', box.id);
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.textContent = open ? 'Leer menos' : 'Leer más';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    box.insertAdjacentElement('afterend', btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clampCollectionText);
  else clampCollectionText();
})();

/* Favoritos (corazón): emite el evento add_to_wishlist para GTM (GA4 / Meta AddToWishlist)
   y para los píxeles personalizados de Shopify. No cambia el comportamiento del corazón. */
(function () {
  function num(t) { var d = (t || '').replace(/[^\d,]/g, '').split(',')[0]; return d ? parseInt(d, 10) : undefined; }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist]');
    if (!btn) return;
    setTimeout(function () {
      if (!btn.classList.contains('wishlist-added')) return;
      var card = btn.closest('.product, .card, .productView') || document;
      var nameEl = card.querySelector('.card-title, .card-information__text, .productView-title, h1');
      var priceEl = card.querySelector('.price-item--sale, .price-item--regular, .price');
      var item = {
        item_id: String(btn.getAttribute('data-product-id') || ''),
        item_name: nameEl ? nameEl.textContent.trim() : (btn.getAttribute('data-wishlist-handle') || ''),
        item_handle: btn.getAttribute('data-wishlist-handle') || '',
        price: priceEl ? num(priceEl.textContent) : undefined,
        currency: 'COP'
      };
      var list = [];
      try { list = JSON.parse(localStorage.getItem('wishlistItem') || '[]'); } catch (err) {}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'add_to_wishlist', wishlist_size: list.length, ecommerce: { currency: 'COP', value: item.price, items: [item] } });
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('add_to_wishlist', item); } catch (err) {}
    }, 0);
  }, true);
})();

/* Accesibilidad (PSI 27-oct-2026): corrige ARIA inválido que viene de secciones/snippets grandes.
   - article.hsp__slide[role=tabpanel]: <article> no admite ese rol -> se quita el rol.
   - [role="recently"] (rol inexistente) -> role=button + teclado (Enter/Espacio dispara el clic).
   No cambia el diseño ni el comportamiento. */
(function () {
  function a11yFix() {
    var i, els = document.querySelectorAll('article.hsp__slide[role="tabpanel"]');
    for (i = 0; i < els.length; i++) els[i].removeAttribute('role');
    els = document.querySelectorAll('[role="recently"]');
    for (i = 0; i < els.length; i++) {
      els[i].setAttribute('role', 'button');
      if (!els[i].hasAttribute('tabindex')) els[i].setAttribute('tabindex', '0');
      els[i].addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', a11yFix);
  else a11yFix();
  window.addEventListener('load', a11yFix);
})();
